import React from 'react'

import Button from '../../../common/Button/Button.tsx'
import Dropdown from '../../../common/forms/Dropdown/Dropdown.tsx'

type FolderNamesProps = {
  options: string[]
  onSelect: (groupName: string | null) => void
  selectedFolderName: string | null
  onClick: () => void
}
const FolderNames = React.forwardRef<HTMLDivElement, FolderNamesProps>(
  ({ options, onSelect, selectedFolderName, onClick }, ref) => {
  return (
    <div
      ref={ref}
      className={
        'flex items-center p-5 flex-col md:flex-row justify-center gap-x-4 border border-gray-200 dark:border-gray-600'
      }
    >
      <p>Wybierz kategorię: </p>
      <Dropdown
        options={options}
        labelExtractor={(item) => item.toString()}
        onSelect={onSelect}
        placeholder="Wybierz z listy"
        makeReset={selectedFolderName === null}
      />
      {selectedFolderName !== null && (
        <Button
          variant="filled"
          size="medium"
          color="primary"
          type="button"
          onClick={onClick}
          className={
            'px-4 py-2 bg-green-700 text-white rounded-md shadow-md hover:bg-green-600 transition-colors'
          }
        >
          Resetuj
        </Button>
      )}
    </div>
  )
})

export default FolderNames
